import Layout from '@/components/Layout';
import FeedbackWidget from './components/FeedbackWidget';

const Feedback = () => {
  return (
    <Layout title="Feedbacks">
      <FeedbackWidget />
    </Layout>
  );
};

export default Feedback;
